<div class="container-fluid py-4 px-5">

  <div class="bg-primary text-white rounded-3 shadow-sm p-3 mb-4">
    <h2 class="h4 mb-0 fw-bold">Búsqueda de Variedades</h2>
  </div>

  <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="row g-2 align-items-center mb-4">
    <div class="col-md-6 col-lg-4">
      <input type="text" formControlName="term"
             class="form-control form-control-lg shadow-sm"
             placeholder="Buscar por nombre de la variedad..." />
    </div>

    <div class="col-md-6 col-lg-4">
      <input type="text" formControlName="ineCode"
             class="form-control form-control-lg shadow-sm"
             placeholder="Buscar por código INE..." />
    </div>

    <div class="col-md-auto d-flex gap-2">
      <button type="submit" class="btn btn-primary btn-lg px-4 shadow-sm">
        <i class="bi bi-search"></i> Buscar
      </button>
      <button type="button" (click)="onListAll()" class="btn btn-outline-secondary btn-lg px-4 shadow-sm">
        <i class="bi bi-list-ul"></i> Consultar todas
      </button>
      <button type="button" (click)="exportExcel()" class="btn btn-success btn-lg px-4 shadow-sm"
        [disabled]="!varieties().length"><i class="bi bi-file-earmark-excel"></i> Exportar Excel</button>
    </div>
  </form>

  @if (loading()) {
    <div class="text-center py-3 text-primary fw-semibold">
      <div class="spinner-border me-2"></div>
      Cargando variedades...
    </div>
  }

  @if (error()) {
    <div class="alert alert-danger text-center">{{ error() }}</div>
  }

  @if (hasSearched() && !loading() && varieties().length === 0) {
    <div class="alert alert-warning text-center">
      <i class="bi bi-exclamation-circle"></i> No se encontraron resultados.
    </div>
  }

  @if (varieties().length > 0) {
    <div class="variety-grid-shell ag-theme-quartz shadow-sm rounded-3">
      <ag-grid-angular
        class="variety-grid"
        [rowData]="varieties()"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [localeText]="localeText"
        [pagination]="true"
        [paginationPageSize]="10"
        [paginationPageSizeSelector]="[10, 25, 50, 100]"
        [animateRows]="true"
        (cellClicked)="onCellClicked($event)">
      </ag-grid-angular>
    </div>
  }

</div>

<app-modal-edit-variety
  [variety]="selectedVariety"
  (deleted)="onVarietyDeleted($event)"
  (updated)="onVarietyUpdated($event)">
</app-modal-edit-variety>
